import styled from 'styled-components';
import { FlexView } from '@cuemath/comps';
import COLORS from 'constants/colors';
import { OVERLAY_BG } from '../../constants';

export const ViewerContainer = styled(FlexView)`
  position: relative;
  width: 100%;
  background: ${COLORS.BLACK};
  margin-bottom: 32px;
  flex-shrink: 0;
  border-radius: 8px;
`;

export const Overlay = styled(FlexView)`
  position: absolute;
  top: 12px;
  right: 12px;
  background: ${OVERLAY_BG};
  padding: 4px 10px;
  border-radius: 4px;
  pointer-events: none;
`;

export const Video = styled.video`
  width: 100%;
  height: 350px;
  display: block;
  object-fit: contain;
  border-radius: 8px;
`;

export const BufferingOverlay = styled(FlexView)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 350px;
  background: ${COLORS.BLACK};
  border-radius: 8px;
  z-index: 1;
  gap: 12px;
`;

export const ProgressBarTrack = styled(FlexView)`
  width: 60%;
  height: 6px;
  background: ${COLORS.WHITE_T_15};
  border-radius: 4px;
  overflow: hidden;
`;

export const ProgressBarFill = styled(FlexView)`
  height: 100%;
  width: ${({ percent }) => percent || 0}%;
  background: ${COLORS.WHITE};
  border-radius: 2px;
  transition: width 0.2s ease;
`;

export const SpeedControls = styled(FlexView)`
  position: absolute;
  bottom: 72px;
  right: 16px;
  z-index: 1;
  gap: 4px;
  background: ${COLORS.WHITE_T_10};
  border-radius: 4px;
  padding: 6px 8px;
`;

export const SpeedButton = styled(FlexView)`
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  background: ${props => (props.isActive ? COLORS.WHITE_T_15 : 'transparent')};

  &:hover {
    background: ${COLORS.WHITE_T_15};
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 450px;
  display: block;
  object-fit: contain;
  border-radius: 8px;
`;
